<template>
  <div>
    <el-dialog
      :visible="visible"
      :show-close="false"
      width="884px"
      custom-class="informationSellers"
      center>
      <div class="informationSellers-card">
        <div class="head">
          <div class="title">卖家须知</div>
          <img class="closeBtn" @click="showClose" src="@/assets/image/AccountDeal/tipClose.png" alt="">
        </div>
        <div class="body">
          <div class="list" >
            <div class="item">
              <div class="title">交易必看</div>
              <div class="text">
                <span>1.卖家</span>
                <span class="color-FFB20C">在游严选平台出售游戏账号必须签署电子合同</span>
                <span>才能进行放款（签署合同时需要提供相关个人信息材料，包括但不限于：身 份信息）。友情提醒：支付宝账号到账较快，微信、银行卡到账较慢。</span>
              </div>
              <div class="text">
                <span>2.</span>
                <span class="color-FFB20C">出售游戏账号发生恶意找回，游严选游戏服务网有权提供相关资料，协助有关部门追回损失；</span>
                <span>若非您本人找回情形您有义务联系前任号主，若您拒绝配合将按本人找回处理；若您能提供有效的首任卖家具体信息与交易凭证（包括但不限于卖家收款记录，订单详情，聊天记录），平台未追回产生的损失与您无关。</span>
              </div>
              <div class="text">
                <span>3.买家下单进行</span>
                <span class="color-FFB20C">账号交易时需支付全额价款，不接受预定金或口头预留等方式。</span>
              </div>
              <div class="text">
                <span>4.交易过程中，请勿出现恶意辱骂，恶意行骗、引导站外等现象，否则，平台有权限制您的账号权限，并视情况封禁账号。</span>
              </div>
              <div class="text">
                <span>5.交易前有任何疑问,请提前咨询客服,</span>
                <span class="color-FFB20C">开始交易即视为认同游严选游戏服务平台所有规则,最终解释权归金华市博淳网络科技有限公司所有。</span>
              </div>
            </div>
            <div class="item">
              <div class="title">交易须知</div>
              <div>
                <span class="tip">
                  <span>注</span>
                  确认验号无误后即为确认交易进入换绑阶段
                </span>
              </div>
              <div class="text">
                <span>1.</span>
                <span class="color-FFB20C">验号无误前双方都可无责取消，确认验号无误后即为确认交易不接受任何理由取消</span>
                <span>，若因个人原因取消交易，需支付订单金额5%违约金，守约方、平台各半收取。 </span>
              </div>
              <div>
                <span class="tip">
                  PS:若卖家违约，拒不支付违约金，将对该账号及该用户多平台拉黑下架。
                </span>
              </div>
              <div class="text">
                <span>2.</span>
                <span class="color-FFB20C">账号进入换绑交接验证码及进入审核后（包含游戏换绑审核期，挂IP等情况），不接受单方面赔付违约金取消，需买卖双方协商处理</span>
                <span>，平台不参与判定责任，最终处理以双方协商一致结果为准，若因游戏厂商原因首次换绑失败，买卖双方需配合平台引导进行账号交付，以顺利交付为主，若确实无法进行换绑交付，将按平台方案进行取消订单。</span>
              </div>
              <div class="text">
                <span>3.</span>
                <span class="color-FFB20C">下单后订单（账号换绑审核期、挂IP等情况除外）理论交易时长为24小时内</span>
                <span>，（具体等待交易时长可由双方协定），如双方无法协定一致将按平台判定方案进行，</span>
                <span class="color-FFB20C">需要在等待交易时长内回应配合交付。如超出理论时长或协定时长，按违约处理。</span>
              </div>
              <div class="text">
                <span>4.交易期间发现黑号记录，经证实后，可取消交易，各方均不承担任何责任。</span>
              </div>
              <div class="text">
                <span class="color-FFB20C">5.交易期间出现毁号，行骗等一切不利于账号的行为，属于侵权行为，若出现纠纷，按买卖双方协商一致结果处理，无法达成一致可通过司法介入，平台配合协助处理，不参与判定责任。</span>
              </div>
              <div class="text">
                <span>6.双方个人承诺等情形，不在平台担保范围之内请理性判断，出现任何风险与损失由您自己承担 ，平台只针对账号找回，人脸包赔等增值业务进行担保。</span>
              </div>
            </div>
            <div class="item">
              <div class="title">卖家须知</div>
              <div class="text">
                <span class="color-FFB20C">1.为保障您的权益，商品换绑后必须签署合同，平台才能根据提交的收款账户进行放款，请持续保持在线，如账号已换绑给买家情况下，签署合同环节失联，账号将由买家游玩，未及时上线签署合同，没有完成交易出现纠纷或损失自行承担。</span>
              </div>
              <div class="text">
                <span>2.若您的游戏账号在多个平台寄售，请保持寄售价格一致，否则账号会被下架；若同一账号多次下单后无理由不交付，默认您有违诚信，平台会下架并联系其他平台拉黑处理该账号。若您寄售的游戏账号在其他地方已出或者不再继续寄售，请务必告知，避免不必要的纠纷。</span>
              </div>
              <div class="text">
                <span>3.您若拿不合法账号(骗取或本人恶意找回)来游严选游戏服务网或者其他平台寄售，游严选游戏服务网会对该账号进行拉黑下架处理，并保留追究法律责任的权利。</span>
              </div>
              <div class="text">
                <span class="color-FFB20C">4.如账号有无法换绑，无法改密等情况交易前或进入交易组后及时告知客服，交付过程出现无法改密等情况导致交付失败，账号安全问题由卖家自行承担。</span>
              </div>
              <div>
                <span class="tip">
                  <span>注</span>
                  本平台只为年满18周岁的成年人提供账号交易，如果您是未成年擅自使用成年家属身份交易的，视为成年家属自己的行为。
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <button v-prevent-re-click @click="agreeBtn" class="agreeBtn">
            我已阅读并同意
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  apicreateRefund,
  apiOrderRefund
} from "@/request/API";

export default {
  name: "informationSellers",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  components: {},
  data() {
    return {
      show:false,
    }
  },
  methods: {
    /**
     * 卖家须知弹窗关闭
     */
    showClose() {
      this.$emit('close')
    },
    /**
     * 阅读并同意按钮
     */
    agreeBtn(){
      this.showClose()
      this.$emit('agree')
    }
  },
  watch: {
    visible(val) {
      this.show = val
    },
  },
  created() {},
  mounted() {}
}
</script>

<style scoped lang="less">

/deep/ .informationSellers {
  border-radius: 4px;
  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  .el-icon-close {
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 800;
  }
}

/deep/ .del {
  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  .el-icon-close {
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 800;
  }
}

.informationSellers-card {
  .head {
    height: 66px;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px 0 44px;

    .title {
      font-size: 22px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .closeBtn {
      width: 25px;
      height: 25px;
      cursor: pointer;
    }
  }

  .body {
    padding: 0 28px 0 26px;
    .list {
      margin: 21px 0 12px;
      height: 585px;
      overflow: auto;
      .item{
        display: flex;
        flex-direction: column;
        margin: 0 0 19px;
        .title{
          font-size: 16px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #F08C2B;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 4px;
          &::before{
             content: '';
             display: block;
             background: #F08C2B;
             width: 4px;
             height: 15px;
             border-radius: 4px;
             margin-right: 6px;
          }
        }
        .text {
          font-size: 14px;
          font-family: PingFang SC-Light, PingFang SC;
          font-weight: 400;
          color: #666;
          line-height: 22px;
          margin: 4px 0;
          .color-FFB20C{
            color: #F08C2B;
          }
        }
        .tip{
          display: inline-block;
          line-height: 26px;
          padding: 0 10px;
          height: 26px;
          background: var(--bg-tag, #F0EDE8);
          border-radius: 4px 4px 4px 4px;
          color: #F7F5F2;
          span{
            display: inline-block;
            font-size: 12px;
            color: #fff;
            width: 20px;
            height: 20px;
            border-radius: 4px;
            background: #F7F5F2;
            line-height: 22px;
            text-align: center;
            transform: scale(0.8);
          }
        }
      }

      .item:last-of-type{
        margin: 0;
      }

      &::-webkit-scrollbar-track {
        border-radius: 4px;
        background: transparent;
      }

      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }

  .footer{
    padding: 0 0 31px;
    text-align: center;
    .agreeBtn{
      width: 298px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      background: var(--primary, #FF5A1F);
      border-radius: 3px;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      border:none;
      padding: 0;
      cursor: pointer;
    }

    .agreeBtn:hover{
      background: var(--primary-hover, #E84A12);
    }
  }

}
</style>
